import { propStyles } from 'src/utils/propStyles';
import { styled } from 'src/utils/styled';

const FilterDropdownText = styled<any, any>(
    'div',
    'filterDropdownText',
    'filterItemDropdown'
)`
    ${propStyles};
    white-space: nowrap;
`;

FilterDropdownText.defaultProps = {
    textAlign: 'left',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: 'inherit',
};

export default FilterDropdownText;



// WEBPACK FOOTER //
// ./src/Components/Filters/Components/StyledComponents/FilterDropdownText.tsx